import { types } from '../types'

const initialState = {
    waiting: false,
    success: false,
    error: '',
    currentChargeAmount: 0,
    minimumAmount: 0

}

const chargeReducer = (state = initialState, { type, action, error }) => {
    switch (type) {


        case types.GET_BANK_GATEWAYS_REQUEST: {

            return {
                ...state,
                getBankGatewaysWaiting: true,
                getBankGatewaysSuccess: false,
                getBankGatewaysError: '',
                bankGateways: undefined

            }
        }

        case types.GET_BANK_GATEWAYS_SUCCESS: {
            return {
                ...state,
                getBankGatewaysWaiting: false,
                getBankGatewaysSuccess: true,
                bankGateways: action.data
            }
        }

        case types.GET_BANK_GATEWAYS_ERROR: {

            return {
                ...state,
                getBankGatewaysWaiting: false,
                getBankGatewaysError: '',
            }
        }


        case types.GET_MINIMUM_CHARGE_AMOUNT_REQUEST: {

            return {
                ...state,
                getMinimumAmountWaiting: true,
                getMinimumAmountSuccess: false,
                getMinimumAmountError: '',
                minimumAmount: 0

            }
        }

        case types.GET_MINIMUM_CHARGE_AMOUNT_SUCCESS: {
            return {
                ...state,
                getMinimumAmountWaiting: false,
                getMinimumAmountSuccess: true,
                minimumAmount: action.data
            }
        }

        case types.GET_MINIMUM_CHARGE_AMOUNT_ERROR: {

            return {
                ...state,
                getMinimumAmountWaiting: false,
                getMinimumAmountError: '',
            }
        }


        case types.GET_VAT_PERCENT_REQUEST: {

            return {
                ...state,
                getVatPercentWaiting: true,
                getVatPercentSuccess: false,
                getVatPercentError: '',
                vatPercent: undefined

            }
        }

        case types.GET_VAT_PERCENT_SUCCESS: {
            return {
                ...state,
                getVatPercentWaiting: false,
                getVatPercentSuccess: true,
                vatPercent: action.data
            }
        }

        case types.GET_VAT_PERCENT_ERROR: {

            return {
                ...state,
                getVatPercentWaiting: false,
                getVatPercentError: '',
            }
        }



        case types.POST_MAKE_CHARGE_REQUEST: {

            return {
                ...state,
                postMakeChargeWaiting: true,
                postMakeChargeSuccess: false,
                postMakeChargeError: false,

            }
        }

        case types.POST_MAKE_CHARGE_SUCCESS: {
            return {
                ...state,
                postMakeChargeWaiting: false,
                postMakeChargeSuccess: true,
            }
        }

        case types.POST_MAKE_CHARGE_ERROR: {

            return {
                ...state,
                postMakeChargeWaiting: false,
                postMakeChargeError: true,
            }
        }


        case types.GET_CURRENT_CHARGE_AMOUNT_REQUEST: {

            return {
                ...state,
                getCurrentChargeAmountWaiting: true,
                getCurrentChargeAmountSuccess: false,
                getCurrentChargeAmountError: '',
                currentChargeAmount: 0,


            }
        }

        case types.GET_CURRENT_CHARGE_AMOUNT_SUCCESS: {
            return {
                ...state,
                getCurrentChargeAmountWaiting: false,
                getCurrentChargeAmountSuccess: true,
                currentChargeAmount: action.data,

            }
        }

        case types.GET_CURRENT_CHARGE_AMOUNT_ERROR: {

            return {
                ...state,
                getCurrentChargeAmountWaiting: false,
                getCurrentChargeAmountError: '',
            }
        }

        case types.PREPARE_FOR_GATEWAY_TO_MAKE_CHARGE_REQUEST: {
            return {
                ...state,
                prepareForGatewayToMakeChargeWaiting: true,
                prepareForGatewayToMakeChargeSuccess: false,
                prepareForGatewayToMakeChargeError: '',
                prepareForGatewayToMakeCharge: null,


            }
        }

        case types.PREPARE_FOR_GATEWAY_TO_MAKE_CHARGE_SUCCESS: {
            return {
                ...state,
                // prepareForGatewayToMakeChargeWaiting: false,
                // prepareForGatewayToMakeChargeSuccess: true,
                prepareForGatewayToMakeCharge: action.data,

            }
        }

        case types.PREPARE_FOR_GATEWAY_TO_MAKE_CHARGE_ERROR: {

            return {
                ...state,
                // prepareForGatewayToMakeChargeWaiting: false,
                prepareForGatewayToMakeChargeError: '',
            }
        }




        case types.CHARGE_PROPS_RESET: {
            return {
                ...state,
                postMakeChargeWaiting: false,
                postMakeChargeSuccess: false,
                postMakeChargeError: '',
                getVatPercentWaiting: false,
                getVatPercentSuccess: false,
                getVatPercentError: '',
                getBankGatewaysWaiting: false,
                getBankGatewaysSuccess: false,
                getBankGatewaysError: '',
                getMinimumAmountWaiting: false,
                getMinimumAmountSuccess: false,
                getMinimumAmountError: '',
                getCurrentChargeAmountWaiting: false,
                getCurrentChargeAmountSuccess: false,
                getCurrentChargeAmountError: '',

            }
        }
        default:
            return state
    }
}

export default chargeReducer;